import { withInstall } from '@mts-fe/utils';
import dropdown from './src/Dropdown.vue';

export * from './src/typing';
export const Dropdown = withInstall(dropdown);
